import { type VariantProps, cva } from 'class-variance-authority';
import type { ComponentProps } from 'react';

import { cn } from '../lib/cn';

/**
 * 목록의 누를 수 있는 한 줄.
 *
 * 여섯 화면이 같은 클래스 문자열을 손으로 복제하고 있었다. `Card`의
 * `interactive` 변형이 그 자리를 위해 있었지만 `div`를 렌더하므로 키보드로는
 * 닿지 않았고, 그래서 아무도 쓰지 않았다 — 실사용 0건이었다.
 *
 * 그 행은 누르는 것이므로 여기서는 `button`이다. `Card`는 면이고 이것은 행이다.
 */
export const listRowVariants = cva(
  cn(
    'border-line px-row py-row w-full rounded-lg border text-left',
    'ease-flow duration-fast transition-colors',
    'hover:border-line-accent hover:bg-highlight',
    'disabled:hover:border-line disabled:cursor-default disabled:opacity-60 disabled:hover:bg-transparent',
  ),
  {
    variants: {
      layout: {
        /** 기본. 안쪽 배치는 호출자가 정한다. */
        block: 'block',
        /** 앞에 순번·아이콘이 서고 본문이 이어지는 행. */
        lead: 'gap-row flex items-start',
        /** 왼쪽 본문 · 오른쪽 상태로 갈라지는 행. */
        split: 'gap-row flex items-center justify-between',
      },
    },
    defaultVariants: { layout: 'block' },
  },
);

/** `Link` 등 button이 아닌 요소에 같은 조판을 줄 때 쓴다 — `inputClassName`과 같은 자리다. */
export function listRowClassName(options?: VariantProps<typeof listRowVariants>) {
  return listRowVariants(options);
}

export interface ListRowProps
  extends ComponentProps<'button'>, VariantProps<typeof listRowVariants> {}

export function ListRow({ className, layout, type = 'button', ...props }: ListRowProps) {
  return <button type={type} className={cn(listRowVariants({ layout }), className)} {...props} />;
}
